export default "__VITE_ASSET__CHNDOiAm__"